<template>
<div>
    <div class="chart-rent-report">
        <charts-closed :dataSet="report.periods"></charts-closed>
        <div class="chart-rent-report__legend--wrapper">
            <p class="chart-rent-report__legend chart-rent-report__legend--green">
                Новые лоты
            </p>
            <p class="chart-rent-report__legend chart-rent-report__legend--gray">
                Закрытые лоты
            </p>
        </div>
        <div class="chart-rent-report__wrapper">
            <p class="chart-rent-report__text" v-html="report.sources">
            </p>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M32 18.84H0.0552979V20.6958H32V18.84Z" fill="#DEDEDE" />
                <path
                    d="M0.0552979 31.9998H2.02372V29.8628H13.2156V22.5518H0.0552979V31.9998ZM2.02372 24.4076H11.2472V28.0069H2.02372V24.4076Z"
                    fill="#DEDEDE" />
                <path
                    d="M15.0734 29.8629H22.4971V32H24.5218V29.8629H31.9456V22.5519H15.0734V29.8629ZM24.5218 24.4078H30.0334V28.007H24.5218V24.4078ZM17.0418 24.4078H22.4971V28.007H17.0418V24.4078Z"
                    fill="#DEDEDE" />
                <path d="M16.9845 0H9.44821V16.9278H16.9845V0ZM15.016 15.0719H11.4166V1.91211H15.016V15.0719Z"
                    fill="#DEDEDE" />
                <path
                    d="M20.8648 5.6801L24.4643 1.91211V16.984H26.4327V5.6801L29.9758 1.91211V16.984H31.9443V0H29.1885L26.4327 2.92441V0H23.6769L18.8964 4.94899V16.984H20.8648V5.6801Z"
                    fill="#DEDEDE" />
                <path
                    d="M5.56783 16.984H7.53625V15.1282V0H4.78046L0 4.94899V15.0719V16.9278H1.96842H5.56783V16.984ZM2.02466 5.6801L5.62407 1.91211V15.0719H2.02466V5.6801Z"
                    fill="#DEDEDE" />
            </svg>
        </div>
    </div>
</div>
</template>

<script>
import ChartsClosed from './ChartsClosed';
export default {
    name: 'RentReportClosed',
    components: {
        ChartsClosed
    },
    mixins: [],
    props: {
        report: {
            type: Object,
            default() {
                return {};
            }
        },
    },
    data() {
        return {};
    },
    mounted() { },
    computed: {
    },
    methods: {}
}
</script>